export default __webpack_public_path__ + "static/media/logo.be9bf9d9.png";